import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../Components/Redux/store';
import { setAuth } from '../Components/Redux/authSlice';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
];

const AddSalaryForm: React.FC = () => {
    const [teacherId, setTeacherId] = useState<number | null>(null);
    const [month, setMonth] = useState<string>('');
    const [amount, setAmount] = useState<string>('');
    const [datePaid, setDatePaid] = useState<string>('');
    const [teachers, setTeachers] = useState<{ id: number; name: string; salary: string }[]>([]);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string>('');
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth.value);
    const navigate = useNavigate();


    // Get current month and date on mount
    useEffect(() => {
        const now = new Date();
        const currentMonth = months[now.getMonth()];
        const currentDate = now.toISOString().split('T')[0];

        setMonth(currentMonth);
        setDatePaid(currentDate);
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const token = getCookie('token');
                if (!token) {
                    dispatch(setAuth(false));
                    return;
                }

                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                await axios.get('/users/user');
                dispatch(setAuth(true));
            } catch (e) {
                dispatch(setAuth(false));
            }
        };

        fetchData();
    }, [dispatch]);

    useEffect(() => {
        const fetchTeachers = async () => {
            try {
                const response = await axios.get('/Branches/teachers/');
                setTeachers(response.data);
            } catch (error) {
                console.error('Error fetching teachers:', error);
            }
        };

        fetchTeachers();
    }, []);

    // Handle teacher selection and auto-populate salary
    const handleTeacherChange = (selectedTeacherId: string) => {
        const teacherIdNum = parseInt(selectedTeacherId) || null;
        setTeacherId(teacherIdNum);

        if (teacherIdNum) {
            const selectedTeacher = teachers.find(t => t.id === teacherIdNum);
            if (selectedTeacher && selectedTeacher.salary) {
                setAmount(selectedTeacher.salary);
            }
        } else {
            setAmount('');
        }
    };

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();

        if (!teacherId || !month || !amount || !datePaid) {
            setErrorMessage('Dhammaan meelaha waa loo baahan yahay');
            return;
        }

        const newSalary = {
            teacher: teacherId,
            month: month,
            amount: amount,
            date_paid: datePaid
        };

        console.log('Submitting new salary:', newSalary);

        try {
            const response = await axios.post('/fees/salaries/', newSalary, {
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            console.log('New salary created:', response.data);
            setShowAlert(true);
            setErrorMessage('');
            setTeacherId(null);
            setMonth('');
            setAmount('');
            setDatePaid('');
            setTimeout(() => {
                navigate('/salaries');
            }, 2000);
        } catch (error) {
            console.error('Error creating salary:', error);
            setErrorMessage('Khalad ayaa dhacay markii la abuurayay mushaarka. Fadlan isku day markale.');
            setShowAlert(false);
        }
    };

    const getCookie = (name: string) => {
        const cookieName = name + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookieArray = decodedCookie.split(';');
        for (let i = 0; i < cookieArray.length; i++) {
            let cookie = cookieArray[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(cookieName) === 0) {
                return cookie.substring(cookieName.length, cookie.length);
            }
        }
        return '';
    };

    return (
        <div className="container-fluid p-4 min-h-screen bg-gray-100 w-full md:ml-[200px] md:w-[calc(100%-200px)]">
            {auth ? (
                <div className="row justify-content-center mt-4 mt-md-5">
                    <div className="col-12 col-md-6 col-lg-5">
                        <div className="card shadow-lg border-0 rounded-lg">
                            <div className="card-body p-4 p-md-5">
                                <h2 className="card-title text-center mb-4 text-xl md:text-2xl font-bold text-gray-800">
                                    Diiwaangeli Mushaar Cusub
                                </h2>
                                {showAlert && (
                                    <div className="alert alert-success alert-dismissible fade show" role="alert">
                                        Si guul leh ayaa loo diiwaangeliyay mushaarka!
                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={() => setShowAlert(false)}
                                            aria-label="Close"
                                        ></button>
                                    </div>
                                )}
                                {errorMessage && (
                                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                        {errorMessage}
                                        <button
                                            type="button"
                                            className="btn-close"
                                            onClick={() => setErrorMessage('')}
                                            aria-label="Close"
                                        ></button>
                                    </div>
                                )}
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="teacherName" className="form-label font-semibold text-gray-700">
                                            Magaca Macalinka
                                        </label>
                                        <select
                                            className="form-select border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                                            id="teacherName"
                                            value={teacherId || ''}
                                            onChange={(e) => handleTeacherChange(e.target.value)}
                                            required
                                        >
                                            <option value="">Dooro Magaca Macalinka</option>
                                            {teachers.map((teacher) => (
                                                <option key={teacher.id} value={teacher.id}>
                                                    {teacher.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="month" className="form-label font-semibold text-gray-700">
                                            Bisha
                                        </label>
                                        <select
                                            className="form-select border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                                            id="month"
                                            value={month}
                                            onChange={(e) => setMonth(e.target.value)}
                                            required
                                        >
                                            <option value="">Dooro Bisha</option>
                                            {months.map((m) => (
                                                <option key={m} value={m}>
                                                    {m}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="amount" className="form-label font-semibold text-gray-700">
                                            Lacagta (KSh)
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                                            id="amount"
                                            value={amount}
                                            onChange={(e) => setAmount(e.target.value)}
                                            placeholder="Si toos ah uga imanaya mushaarka macalinka"
                                            required
                                        />
                                        <small className="text-muted">Lacagta waxay si toos ah uga imaaneysaa mushaarka macalinka</small>
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="datePaid" className="form-label font-semibold text-gray-700">
                                            Taariikhda Bixinta
                                        </label>
                                        <input
                                            type="date"
                                            className="form-control border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                                            id="datePaid"
                                            value={datePaid}
                                            onChange={(e) => setDatePaid(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="d-grid">
                                        <button
                                            type="submit"
                                            className="btn btn-primary btn-lg bg-blue-600 hover:bg-blue-700 transition-colors duration-200"
                                        >
                                            Gudbi
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="text-center mt-5">
                    <h4 className="text-gray-600 text-lg md:text-xl">Ma aadan xaqiijin</h4>
                    <a href="/login" className="btn btn-primary mt-3">
                        Aad Login
                    </a>
                </div>
            )}
        </div>
    );
};

export default AddSalaryForm;